angular.module('qkr').controller('Finance1ControllerModal', Finance1ControllerModal);

function Finance1ControllerModal($scope, $rootScope, $routeSegment, $uibModalInstance, merchantService, $timeout,
                                 reportInfo, departments, reportService, appConfig, utils, gettextCatalog,
                                 reportsErrorService) {

    const vm = this;
    const now = new Date() * 1;
	const defaultScheduleInterval = 'daily';
    const defaultScheduleHour = 17;
    const defaultScheduleMinute = 30;
    const defaultScheduleDay = utils.getDaysOfWeek()[0].name;
    const defaultScheduleDayOfMonth = 1;
    const defaultDaysOfBankCutOff = '5d';
    const defaultNonInvoice = ' NonInvoice';

    const isUpdating = Boolean(reportInfo.report);
    vm.departments = departments;

    vm.$routeSegment = $routeSegment;
    vm.reportType = reportInfo.reportType;

    vm.daysOfMonth = reportService.getDaysOfMonth();
    vm.daysOfWeek = utils.getDaysOfWeek();  // Drop down menu to choose which day to generate weekly report
    vm.days = utils.getDaysOfWeekWithSelected();   // Used to select which days a daily report should be generated on
    vm.scheduleIntervals = reportService.getExtendedScheduleIntervals(); // Includes 5 day daily (bank reconcile)
    vm.hours = reportService.getHours();
    vm.minutes = reportService.getMinutes();

    vm.form = {};
    vm.form.finance1ReportForm = {};

    vm.finance1ReportSettings = {
        reportWaiting: false,
        reportUrl: '',
        showGenerateButton: !(isUpdating || merchantService.behaviour(merchantService.merchantInfo,
            'reportPage.collapseHeaders')),
        showSaveButton: isUpdating,
        showFinance1Accountancy: merchantService.behaviour(merchantService.merchantInfo,
            'storeFrontPage.showFinance1Accountancy')
    };

    vm.finance1Report = {
        date: {
            startDate: now,
            startTime: reportService.getDateTime(0, 0, 0),
            endDate: now,
            endTime: reportService.getDateTime(23, 59, 59)
        },
        startTime: null,
        endTime: null,
        reportSpec: {
        	reportSubType: 'Finance 1 NonInvoice', // Init() changes this to finance1 or Synergetic
            scheduleInterval: 'once',
            departments: []
        }
    };

    vm.finance1ReportTemplate = {
        reportSpec: {
            scheduleInterval: defaultScheduleInterval,
            scheduleHour: defaultScheduleHour,
            scheduleDay: defaultScheduleDay,
            scheduleDayOfMonth: defaultScheduleDayOfMonth,
            emailList: [],
            scheduleMinute: defaultScheduleMinute,
            reportSubType: 'Finance 1 NonInvoice', // Init() changes this to finance1 or Synergetic
            departments: [],
            daysOfBankCutOff: defaultDaysOfBankCutOff
        }
    };

    vm.departments = [];

    // This is needed if the user is editing a template and they change from daily to weekly
    // If the schedule selected is not daily, and scheduleDay contains a "," i.e. a list of days,
    // then select the first day E.g. if daily and "WED,THU,FRI", and weekly is selected, then the
    // default day will be set to the first day in the list, i.e. WED
    $scope.$watch('finance1ReportTemplate.reportSpec.scheduleInterval', (newValue, oldValue) => {
        if (newValue !== 'daily' && vm.finance1ReportTemplate.reportSpec.scheduleDay.indexOf(',') > -1) {
            const dayArray = vm.finance1ReportTemplate.reportSpec.scheduleDay.split(',');
        vm.finance1ReportTemplate.reportSpec.scheduleDay = dayArray[0];
        }
    });

    var poll = function(id, format, reportType) {
        const timeoutPoll = $timeout(() => {
            // Poll for report

            reportService.pollReport(id)
                .then((promise) => {
                    // Check if error on the report
                    if (promise.error) {
                        handleGenerateReportError(promise);
                    } else if (promise.reportType === 'no-data') {
                        vm.form.finance1ReportForm.errors = {generate: gettextCatalog
                            .getString('No data for these criteria')};
                        vm.finance1ReportSettings.reportWaiting = false;
                    }
                    // Check if complete, otherwise poll again
                    else if (promise.percentComplete === 100) {
                        vm.form.finance1ReportForm.errors = {};
                        vm.finance1ReportSettings.reportWaiting = false;
                        vm.finance1ReportSettings.reportUrl = appConfig.apiUrl
                            + 'reportControl/' + promise.id + '/' + format;
                        window.location = vm.finance1ReportSettings.reportUrl;
                    } else {
                        poll(id, format, reportType);
                    }
            },
            (error) => {
                handleGenerateReportError(error);
            });
        }, 2500);

        // When the DOM element is removed from the page, AngularJS will trigger the $destroy event on
        // The scope. This gives us a chance to cancel any pending timer that we may have.
        $scope.$on(
            '$destroy',
            (event) => {
                $timeout.cancel(timeoutPoll);
            }
         );
    };

    var handleGenerateReportError = function(error) {
        let errors = {};

        if (vm.form.finance1ReportForm.errors) {
            errors = vm.form.finance1ReportForm.errors;
        }

        errors.generate = gettextCatalog.getString('Error generating report');
        vm.form.finance1ReportForm.errors = errors;
        vm.finance1ReportSettings.reportWaiting = false;
    };


    /** Update departments list shown on form from list of departments and set the ones that should be selected */
    var updateDepartmentsList = function(reportSpec, departments) {
        reportSpec.departments = [];
        let selectedCount = 0;
        for (var i = 0; i < departments.length; ++i) {
            let selected = false;
            if (!(typeof reportSpec.merchantLocs === 'undefined')) {
                for (let j = 0; j < reportSpec.merchantLocs.length; j++) {
                    if (reportSpec.merchantLocs[j].id == departments[i].id) {
                        selected = true;
                        selectedCount++;
                    }
                }
            }
            reportSpec.departments.push({id: departments[i].id, name: departments[i].name, selected});
        }

        // If no departments are selected then select all of them (none selected means report will contain
        // All departments, so may as well show them all ticked as it is the same thing). Also when a
        // New report is  being created they will all be selected so they just need to unselect ones they
        // Don't want (typically Canteen).
        if (selectedCount === 0) {
            for (var i = 0; i < departments.length; ++i) {
                reportSpec.departments[i].selected = true;
            }
        }
    };

    vm.generateFinance1Report = function() {
        vm.finance1ReportSettings.reportWaiting = true;

        const request = angular.copy(vm.finance1Report);
        request.reportSpec.scheduleInterval = 'once';
        request.startTime = utils.dateTimeToServerDateTimeString(vm.finance1Report.date.startDate, vm.finance1Report.date.startTime); // Start of day
        request.endTime = utils.dateTimeToServerDateTimeString(vm.finance1Report.date.endDate, vm.finance1Report.date.endTime); // End of day
        request.reportSpec.reportSubType = vm.reportType + defaultNonInvoice;
        setMerchantLocIds(request.reportSpec, vm.finance1Report.reportSpec);
        delete (request.date);

        reportService.generateFinance1Report(request)
            .then((promise) => {
                poll(promise.id, 'excel', 'finance1');
            },
            (error) => {
                handleGenerateReportError(error);
            });
    };

    /** Set the merchantLocs that are selected in the report spec (that will be sent to server) */
    var setMerchantLocIds = function(requestReportSpec, reportSpec) {
        requestReportSpec.merchantLocs = [];
        if (typeof reportSpec.departments === 'undefined') {
            reportSpec.departments = [];
        }
        for (let i = 0; i < reportSpec.departments.length; ++i) {
            if (reportSpec.departments[i].selected) {
                requestReportSpec.merchantLocs.push({id: reportSpec.departments[i].id});
            }
        }
        delete requestReportSpec.departments; // Don't send departments to server
    };

    vm.saveFinance1Report = function() {
        if (!validateReport()) {
            return;
        }

        vm.saving = true;

        const request = angular.copy(vm.finance1ReportTemplate.reportSpec);
        setMerchantLocIds(request, vm.finance1ReportTemplate.reportSpec);
        request.reportSubType = vm.reportType + defaultNonInvoice;
        if (request.scheduleInterval === defaultScheduleInterval) {
            request.scheduleDay = utils.getSelectedDaysList(vm.days);
        }

        // Are we updating or creating, if savedReport object passed to modal we are updating, otherwise we are creating
        if (!isUpdating) {
            request.id = null;
        }

        reportService.saveFinance1Report(request, isUpdating)
            .then(() => {
                $uibModalInstance.close(true);
            })
            .catch(response => {
                vm.form.finance1ReportForm.errors = reportsErrorService
                    .handleServerError(response.data.errors);
            })
            .finally(() => {
                vm.saving = false;
            });
    };

    var validateReport = function() {
        // Empty the errors list
        vm.errors = null;
        let valid = true;
        const errors = {};

        // Check name is set
        if (vm.form.finance1ReportForm.name) {
        	errors.name = gettextCatalog.getString('Name is required');
            valid = false;
        }

        // Check at least 1 email is added
        if (vm.finance1ReportTemplate.reportSpec.emailList.length <= 0) {
        	errors.email = gettextCatalog.getString('At least 1 email address is required');
            valid = false;
        }

        vm.form.finance1ReportForm.errors = errors;

        return valid;
    };

    vm.addFinance1ReportEmail = function() {
        // Gets ride of validation warning
        if (vm.form.finance1ReportForm.errors && vm.form.finance1ReportForm.errors.email) {
            vm.form.finance1ReportForm.errors.email = '';
        }

        vm.finance1ReportTemplate.reportSpec.emailList.push(vm.finance1ReportSettings.email);
        vm.finance1ReportSettings.email = '';
    };

    vm.removeFinance1ReportEmail = function(index) {
    vm.finance1ReportTemplate.reportSpec.emailList.splice(index, 1);
    };

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    /* Init */
    vm.init = function() {

        // vm.reportType is displayed to user at top of dialog. For Finance1 we want it to be uppercase.
        vm.reportType = reportInfo.reportType;

        if (isUpdating) {
            vm.finance1ReportTemplate.reportSpec = reportInfo.report;
            // ScheduleDayOfMonth is return as string from server
            vm.finance1ReportTemplate.reportSpec.scheduleDayOfMonth =
                parseInt(vm.finance1ReportTemplate.reportSpec.scheduleDayOfMonth);
            utils.setSelectedDays(vm.finance1ReportTemplate.reportSpec.scheduleDay, vm.days);
        } else {
            vm.finance1Report.reportSpec.reportSubType = reportInfo.reportType + ' Invoice';
            vm.finance1ReportTemplate.reportSpec.reportSubType = reportInfo.reportType + ' Invoice';
        }
        updateDepartmentsList(vm.finance1Report.reportSpec, departments);
        updateDepartmentsList(vm.finance1ReportTemplate.reportSpec, departments);
    };

    /** Called when day is toggled in daily report */
    vm.changeDayEnabled = function(day) {
        day.selected = !day.selected;
    };

    vm.dateOptions = {
        startingDay: $rootScope.merchantInfo.contactDetails.country.weekStartingDay,
        showWeeks: false
    };
    vm.init();
}


// WEBPACK FOOTER //
// ./src/reports/outlet/shared/finance1.modal.controller.js